import Vue from 'vue'
import GiftForm from "./components/GiftForm.vue";
import VipForm from "./components/VipForm.vue";
import RedeemForm from "./components/RedeemForm.vue";

Vue.config.productionTip = false

import axios from 'axios'
import VueAxios from 'vue-axios'

import VeeValidate from 'vee-validate'

import './assets/styles.css';


// import Swal from "sweetalert2";

Vue.use(VueAxios, axios)

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

Vue.use(VeeValidate, {
  classes: true,
});

// var qs = require('qs');

new Vue({
  render: h => h(GiftForm),
}).$mount('#noni_gift_form')


new Vue({
  render: h => h(VipForm),
}).$mount('#noni_vip_form')


new Vue({
  render: h => h(RedeemForm),
}).$mount('#noni_redeem_form')
